import * as React from 'react';
import ReactGA from 'react-ga';
import { useState, useEffect, useCallback } from 'react';
import styled, {keyframes} from 'styled-components'
import { Link } from 'react-router-dom';
import QuestionResult from '../Data/QustionResult.json';
import Bonus from "../Img/bonus@3x.png";
import ISTJ from "../Img/istj@3x.png";
import INFJ from "../Img/infj@3x.png";
import INTJ from "../Img/intj@3x.png";
import ISFJ from "../Img/isfj@3x.png";
import ISTP from "../Img/istp@3x.png";
import ISFP from "../Img/isfp@3x.png";
import INFP from "../Img/infp@3x.png";
import INTP from "../Img/intp@3x.png";
import ESTP from "../Img/estp@3x.png";
import ESFP from "../Img/esfp@3x.png";
import ENTP from "../Img/entp@3x.png";
import ESTJ from "../Img/estj@3x.png";
import ENFP from '../Img/enfp@3x.png';
import ESFJ from "../Img/esfj@3x.png";
import ENFJ from "../Img/enfj@3x.png";
import ENTJ from "../Img/entj@3x.png";
import appIcon from '../Img/app-icon.svg';
import google from '../Img/google-btn.svg';
import appStore from '../Img/appstore-btn.svg';
import ReviewImg from "../Img/review@3x.png";
import JoinEvent from "../Img/event-banner@3x.png";
import logo from "../Img/logo@3x.png";
import sppech from "../Img/speech-bubble.svg";
import SocialButtonList from "./Share/SocialButtonList";
import { HelmetProvider, Helmet } from "react-helmet-async";
import copyright from "../Img/copyright@2x.png";


interface ResultProps {
    type: string;
}

interface InfoResultList {
    id: number;
    type: string;
    title: string;
    subTitle: string;
    titleInfo: string;
    description: string;
    hashTag: string;
    sppech: string;
    love: string;
    money: string;
    metaTitle: string;
}

const analyticsId = 'G-EK0Y8CQQZH';



declare const window: any;
declare const gtag: any;
declare const fbq: any;


const checkMobile = () => {
    var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기
    if ( varUA.indexOf('android') > -1) {
        //안드로이드
        gtag('event', 'Logo_Url', {
            event_category: 'Android',
            event_label: 'Android',
            value: 'Android'
        })
        gtag('event', 'Android_Logo_Url', {
            event_category: 'Android',
            event_label: 'Android',
            value: 'Android'
        })
        fbq('track', 'Logo_Url' , {
            value: 'Android'
        })
        return window.open("https://app.adjust.com/t1f5cze", "", "_blank");
    } else if ( varUA.indexOf("iphone") > -1||varUA.indexOf("ipad") > -1||varUA.indexOf("ipod") > -1 ) {
        //IOS
        gtag('event', 'Logo_Url', {
            event_category: 'Ios',
            event_label: 'Ios',
            value: 'Ios'
        })
        gtag('event', 'Ios_Logo_Url', {
            event_category: 'Android',
            event_label: 'Android',
            value: 'Android'
        })
        fbq('track', 'Logo_Url' , {
            value: 'Ios'
        })
        return window.open("https://app.adjust.com/a5ewcmt", "", "_blank");
    } else {
        //아이폰, 안드로이드 외
        gtag('event', 'Logo_Url', {
            event_category: 'Android',
            event_label: 'Android',
            value: 'Android'
        })
        gtag('event', 'Android_Logo_Url', {
            event_category: 'Android',
            event_label: 'Android',
            value: 'Android'
        })
        fbq('track', 'Logo_Url' , {
            value: 'Android'
        })
        return window.open("https://app.adjust.com/t1f5cze", "", "_blank");
    }
}

const Result: React.FC<ResultProps> = ({ type }) => {
    const [ resultList, setResultList ] =useState<Partial<InfoResultList>>({});

    const fetchResults = useCallback((QuestionResult, type) => {
        Object.keys(QuestionResult.questionResult).forEach(key => {
            if (QuestionResult.questionResult[key].type === type) {
                setResultList(QuestionResult.questionResult[key]);
            }
        });
    }, []);


    useEffect(() => {
        if (type !== null)
            fetchResults(QuestionResult, type);
    }, [type, fetchResults]);



    const ogMetaTitle = document.getElementsByTagName('META')[10] as HTMLMetaElement;

    ogMetaTitle.content  = `${resultList.metaTitle}`;


    const metaDescription = document.getElementsByTagName('META')[4] as HTMLMetaElement;
    const ogMetaDescription = document.getElementsByTagName('META')[9] as HTMLMetaElement;
    metaDescription.content  = `${resultList.hashTag}`;
    ogMetaDescription.content  = `${resultList.hashTag}`;

    // const metaImage = document.getElementsByTagName('META')[4] as HTMLMetaElement;
    // const ogMetaImage = document.getElementsByTagName('META')[10] as HTMLMetaElement;
    //
    // if(type ==="ISTJ") { metaImage.content = "http://dev.moditt.com/front/tarotmoon_test/resultImg/ISTJ.png"; ogMetaImage.content = "http://dev.moditt.com/front/tarotmoon_test/resultImg/ISTJ.png"; }
    // if(type ==="ISFJ") { metaImage.content = "http://dev.moditt.com/front/tarotmoon_test/resultImg/ISFJ.png"; ogMetaImage.content = "http://dev.moditt.com/front/tarotmoon_test/resultImg/ISFJ.png"; }
    // if(type ==="INFJ") { metaImage.content = "http://dev.moditt.com/front/tarotmoon_test/resultImg/INFJ.png"; ogMetaImage.content = "http://dev.moditt.com/front/tarotmoon_test/resultImg/INFJ.png"; }
    // if(type ==="INTJ") { metaImage.content = "http://dev.moditt.com/front/tarotmoon_test/resultImg/INTJ.png"; ogMetaImage.content = "http://dev.moditt.com/front/tarotmoon_test/resultImg/INTJ.png"; }
    // if(type ==="ISTP") { metaImage.content = "http://dev.moditt.com/front/tarotmoon_test/resultImg/ISTP.png"; ogMetaImage.content = "http://dev.moditt.com/front/tarotmoon_test/resultImg/ISTP.png"; }
    // if(type ==="ISFP") { metaImage.content = "http://dev.moditt.com/front/tarotmoon_test/resultImg/ISFP.png"; ogMetaImage.content = "http://dev.moditt.com/front/tarotmoon_test/resultImg/ISFP.png"; }
    // if(type ==="INFP") { metaImage.content = "http://dev.moditt.com/front/tarotmoon_test/resultImg/INFP.png"; ogMetaImage.content = "http://dev.moditt.com/front/tarotmoon_test/resultImg/INFP.png"; }
    // if(type ==="INTP") { metaImage.content = "http://dev.moditt.com/front/tarotmoon_test/resultImg/INTP.png"; ogMetaImage.content = "http://dev.moditt.com/front/tarotmoon_test/resultImg/INTP.png"; }
    // if(type ==="ESTP") { metaImage.content = "http://dev.moditt.com/front/tarotmoon_test/resultImg/ESTP.png"; ogMetaImage.content = "http://dev.moditt.com/front/tarotmoon_test/resultImg/ESTP.png"; }
    // if(type ==="ENFP") { metaImage.content = "http://dev.moditt.com/front/tarotmoon_test/resultImg/ENFP.png"; ogMetaImage.content = "http://dev.moditt.com/front/tarotmoon_test/resultImg/ENFP.png"; }
    // if(type ==="ESFP") { metaImage.content = "http://dev.moditt.com/front/tarotmoon_test/resultImg/ESFP.png"; ogMetaImage.content = "http://dev.moditt.com/front/tarotmoon_test/resultImg/ESFP.png"; }
    // if(type ==="ENTP") { metaImage.content = "http://dev.moditt.com/front/tarotmoon_test/resultImg/ENTP.png"; ogMetaImage.content = "http://dev.moditt.com/front/tarotmoon_test/resultImg/ENTP.png"; }
    // if(type ==="ESTJ") { metaImage.content = "http://dev.moditt.com/front/tarotmoon_test/resultImg/ESTJ.png"; ogMetaImage.content = "http://dev.moditt.com/front/tarotmoon_test/resultImg/ESTJ.png"; }
    // if(type ==="ESFJ") { metaImage.content = "http://dev.moditt.com/front/tarotmoon_test/resultImg/ESFJ.png"; ogMetaImage.content = "http://dev.moditt.com/front/tarotmoon_test/resultImg/ESFJ.png"; }
    // if(type ==="ENFJ") { metaImage.content = "http://dev.moditt.com/front/tarotmoon_test/resultImg/ENFJ.png"; ogMetaImage.content = "http://dev.moditt.com/front/tarotmoon_test/resultImg/ENFJ.png"; }
    // if(type ==="ENTJ") { metaImage.content = "http://dev.moditt.com/front/tarotmoon_test/resultImg/ENTJ.png"; ogMetaImage.content = "http://dev.moditt.com/front/tarotmoon_test/resultImg/ENTJ.png"; }

    const metaURL = document.getElementsByTagName('META')[7] as HTMLMetaElement;
    const ogMetaURL = document.getElementsByTagName('META')[8] as HTMLMetaElement;
    metaURL.content = `${window.location.href}`;
    ogMetaURL.content = `${window.location.href}`;





    return (
        <HelmetProvider>
        <section>
            <Helmet>
                <title>{resultList.metaTitle}</title>

            </Helmet>
            {resultList &&
            <Contents>
                <TextWrap>
                    <InnerTextWrap>
                        <img src={logo} alt="" className="logo" onClick={() => checkMobile()}/>
                    <FixTitle>나의 찐본캐는</FixTitle>
                    <Title>{resultList.title}</Title>
                    <SubTitle>{resultList.subTitle}</SubTitle>
                        {type === "ISFP" ? <TitleInfo><p>{resultList.titleInfo}</p></TitleInfo> : null}
                    <Image>
                        {type === "ISTJ" ? <img src={ISTJ} alt={type} id="result_img"/>:null}
                        {type === "ISFJ" ? <img src={ISFJ} alt={type} id="result_img"/>:null}
                        {type === "INFJ" ? <img src={INFJ} alt={type} id="result_img"/>:null}
                        {type === "INTJ" ? <img src={INTJ} alt={type} id="result_img"/>:null}
                        {type === "ISTP" ? <img src={ISTP} alt={type} id="result_img"/>:null}
                        {type === "ISFP" ? <img src={ISFP} alt={type} id="result_img"/>:null}
                        {type === "INFP" ? <img src={INFP} alt={type} id="result_img"/>:null}
                        {type === "INTP" ? <img src={INTP} alt={type} id="result_img"/> :null}
                        {type === "ESTP" ? <img src={ESTP} alt={type} id="result_img"/>:null}
                        {type === "ENFP" ? <img src={ENFP} alt={type} id="result_img"/> :null}
                        {type === "ESFP" ? <img src={ESFP} alt={type} id="result_img"/>:null}
                        {type === "ENTP" ? <img src={ENTP} alt={type} id="result_img"/>:null}
                        {type === "ESTJ" ? <img src={ESTJ} alt={type} id="result_img"/>:null}
                        {type === "ESFJ" ? <img src={ESFJ} alt={type} id="result_img"/>:null}
                        {type === "ENFJ" ? <img src={ENFJ} alt={type} id="result_img"/>:null}
                        {type === "ENTJ" ? <img src={ENTJ} alt={type} id="result_img"/>:null}
                    </Image>
                    <HashTag>{resultList.hashTag}</HashTag>
                    <Description> {resultList.description}</Description>
                    <SubContentsTitle>찐본캐의 한 마디</SubContentsTitle>
                    <Bubble>
                        <img src={sppech} />
                        <BubbleText>
                        <label>
                            나 사실...
                        </label>
                        <p>
                            {resultList.sppech}
                        </p>
                        </BubbleText>
                    </Bubble>
                    <Unse>
                        <TaroUnse>
                            <img src={Bonus} alt=""/>
                            <label>올해의 타로 운세</label>
                            <p className="MasterComment">
                                타로문에서 활동 중인 타로마스터와 함께 제작하였습니다
                            </p>
                            <UnseBox>
                                <label>연애운</label>
                                <p>{resultList.love}</p>
                            </UnseBox>
                            <UnseBox>
                                <label>금전운</label>
                                <p>{resultList.money}</p>
                            </UnseBox>
                        </TaroUnse>
                    </Unse>
                    </InnerTextWrap>
                    <Share>
                        <label>친구들에게 나의 찐본캐를 알려주세요!</label>
                        <SocialButtonList
                            shareLink={String(resultList.type)}
                            shareTitleButton={String(resultList.title)}
                            shareName={String(resultList.subTitle)}
                            shareDescription={String(resultList.hashTag)}
                        />
                       <Link to="/"
                             onClick={() => {
                                 gtag('event', 'Test_Again', {
                                     event_category: 'Test_Again',
                                     event_label: 'Test_Again',
                                     value: 'Test_Again'
                                 })
                                 fbq('track', 'Test_Again' , {
                                     value: 'Test_Again'
                                 });
                             }}
                       >
                            <Button
                            ><label>테스트 다시하기</label></Button>
                        </Link>
                        <label>밖에 나가기 걱정되는 요즘</label>
                        <label>집에서 타로점 어때요? </label>
                        <div
                            onClick={()=> {
                                gtag('event', 'Youtube_Watch_a_video' , {
                                    event_category: 'Youtube_Watch_a_video',
                                    event_label: 'Youtube_Watch_a_video',
                                    value: 'Youtube_Watch_a_video',
                                    'non_interaction': true
                                });
                                fbq('track', 'Youtube_Watch_a_video' , {
                                    value: 'Youtube_Watch_a_video'
                                });
                            }}
                        >
                        <Youtube >
                            <iframe width="315" height="177" src="https://www.youtube.com/embed/ZJ-NKsmU2U4"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen></iframe>
                        </Youtube>
                        </div>
                        <SubLabel>
                            #유튜버후기 #소름돋음 #연애운_잘보는_곳
                        </SubLabel>
                    </Share>
                    <App>
                        <AppContents>
                            <img src={appIcon} alt=""/>
                            <label>
                                집에서 즐기는 비대면 타로점 앱,<b> 타로문</b>
                                <br/>지금 바로 다운로드해 보세요!
                            </label>
                            <div>
                                <a onClick={(event: any) => {window.open("https://app.adjust.com/ph5g0sq", "", "_blank")}} className="google_app">
                                    <AppButton
                                        onClick={()=> {
                                            gtag('event', 'App_Download' , {
                                                event_category: 'Android',
                                                event_label: 'Android',
                                                value: 'Android'
                                            });
                                            gtag('event', 'Android_Download' , {
                                                event_category: 'Android',
                                                event_label: 'Android',
                                                value: 'Android'
                                            });
                                            fbq('track', 'App_Download' , {
                                                value: 'Android'
                                            });
                                        }}>
                                      <img src={google} alt="google" style={{float: "left"}}/>
                                    </AppButton>
                                </a>
                                <a onClick={(event: any) => {window.open("https://app.adjust.com/wsp6cl3","", "_blank")}} className="ios_app">
                                    <AppButton
                                        onClick={()=> {
                                            gtag('event', 'App_Download' , {
                                                event_category: 'Ios',
                                                event_label: 'Ios',
                                                value: 'Ios'
                                            });
                                            gtag('event', 'Ios_Download' , {
                                                event_category: 'Ios',
                                                event_label: 'Ios',
                                                value: 'Ios'
                                            });
                                            fbq('track', 'App_Download' , {
                                                value: 'Ios'
                                            });
                                        }}
                                    >
                                     <img src={appStore} alt="appStore" style={{float: "right"}}/>
                                    </AppButton>
                                </a>
                            </div>
                        </AppContents>
                    </App>
                    <InnerTextWrap>
                        <Review>
                            <h1>
                                리/얼/후/기
                            </h1>
                            <label>진짜 잘 보는 타로마스터만 모여있으니까!</label>
                            <img src={ReviewImg} alt="" style={{margin: "30px 0"}}/>
                        </Review>
                    </InnerTextWrap>
                    <Event>
                        <img src={JoinEvent} alt=""/>
                    </Event>
                    <Footer>
                        <img src={copyright} alt="copyright"/>
                        {/*<Adress>*/}
                        {/*    <p>*/}
                        {/*        (주)모딧 ㅣ 타로문 Tarotmoon(by Moditt co., ltd.) ㅣ 대표: 권영국*/}
                        {/*        주소: 서울시 강남구 논현로98길 28 306 ㅣ 사업자번호: 202-86-00196*/}
                        {/*        통신판매업신고번호: 2016-서울강남-01003호*/}
                        {/*        이메일: contact@tarotmoon.co.kr*/}
                        {/*    </p>*/}
                        {/*</Adress>*/}
                        {/*<Company>*/}
                        {/*    <p>*/}
                        {/*        Copyright :: Tarotmoon and Moditt co.,  ltd. all rights reserved*/}
                        {/*    </p>*/}
                        {/*</Company>*/}
                    </Footer>
                </TextWrap>
            </Contents>
                }
        </section>
        </HelmetProvider>
    );
};

export default Result;

const fadein = keyframes`
       from {
            opacity: 0;
            transform: translateY(50px);
        }
 
        to {
            opacity: 1;
            transform: none;
        }
    }
`
const Contents = styled.div `
    height: inherit;
    min-width: 375px;
    max-width: 375px;
    margin: 0 auto 0 auto;
`
const TextWrap = styled.div `
    margin: 60px 0 0 0;
    float: left;
    width: 375px;
    height: 100%;
     @media (max-width: 1024px) {
        margin: 30px 0 0 0;n
     }
`
const InnerTextWrap = styled.div `
    float: left;
    margin: 0 30px;
    .logo {
        width: 125px;
        height: 25px;
        cursor: pointer;
    }
`
const TitleInfo = styled.label`
  margin: 20px 0 0 0;
  float: left;
  font-family: NanumGothic;
  font-size: 12px;
  height: 40px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  text-align: left;
  color: #dddddd;
  p {
    margin: 0 auto;
    padding: 0;
  }
`

const FixTitle = styled.h5 `
    font-family: GmarketSansTTF;
    margin: 50px 0 10px 0;
    font-size: 18px;
    height: 18px;
    font-weight: 500;
    line-height: normal;
    color: #9a9a9a;
`
const Title = styled.label `
    font-family: GmarketSansTTFBold;
    width: 100%;
    float: left;
    font-size: 32px;
    font-weight: 700;
    line-height: 42px;
    color: #ffffff;
`
const SubTitle = styled.label `
    font-family: GmarketSansTTFBold;
    width: 100%;
    float: left;
    font-size: 32px;
    font-weight: 700;
    line-height: 42px;
    color: #ffcf24;
`
const Image = styled.div `
    width: 100%;
    height: 260px;
    float: left;
    img {
    width: 100%;
    margin: 30px 0;
    animation: ${fadein} 0.3s ease-in;
    }
`

const HashTag = styled.h2 `
    font-family: GmarketSansTTF;
    font-size: 18px;
    font-weight: 500;
    line0height: normal;
    color: #ffffff;
`
const Description = styled.div `
    margin: 30px 0 50px 0;
    width: 100%;
    height:100%;
    font-family: 'NanumGothic',sans-serif ;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 24px;
    letter-spacing: normal;
    color: #dddddd;
    text-align: left;
`
const SubContentsTitle = styled.label `
    font-family: GmarketSansTTFBold;
    font-size: 26px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
`
const Bubble = styled.div `
    font-family: GmarketSansTTF;
    // margin: 20px 0 0 0;
    padding: 20px 0 0 0;
    width: 315px;
    position:relative;
    text-align:center;
    float: left;
    img {
        vertical-align: middle;
    }
    
`
const BubbleText = styled.div`
    position: absolute;
    width: 100%;
    // height: 100%;
    top: 46px;
    // left:50%;
    // transform: translate(-50%, -50%); 

    label {
          width: 100%;
          font-size: 16px;
          font-weight: 500;
          font-stretch: normal;
          font-style: normal;
          line-height: normal;
          letter-spacing: normal;
          text-align: center;
          color: #000000;
    }
    p {
          width: 100%;
          font-size: 20px;
          font-family:GmarketSansTTFBold;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.2;
          letter-spacing: normal;
          text-align: center;
          color: #000000;
          margin: 5px 0 0 0;
    }
    
`
const Unse = styled.div`
    padding: 60px 0;
    width: 100%;
    height: 100%;
    float: left;
`
const TaroUnse = styled.div`
    width: 100%;
    height: 100%;
    float: left;
    .MasterComment {
      width: 100%;
      float: left;
      margin: 0 0 20px 0;
      font-family: NanumGothic;
      font-size: 12px;
      height: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: #dddddd;
    }
    
        img {
        width: 60px;
        height: 40px;
        float: left;
        padding: 0 0 10px 60px;
        }
        @media (max-width: 1024px) {
             img {
                padding: 0 0 10px 52px;
        }
        }
        label {
        font-family: GmarketSansTTFBold;
          float: left;
          width: 100%;
          height: 26px;
          font-size: 26px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: normal;
          letter-spacing: normal;
          text-align: center;
          color: #ffffff;
          padding: 0 0 20px 0;
      }
`
const UnseBox = styled.div`
  float: left;
  width: 100%;
  height: 100%;
  margin: 10px 0;
  
  border-radius: 8px;
  background-color: #32355a;
  label {
      font-family: GmarketSansTTF;
      font-size: 16px;
      height: 16px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: #ffcf24;
      padding: 30px 0 20px 0;
  }
  p {
     font-family: NanumGothic;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 24px;
      letter-spacing: normal;
      color: #dddddd;
      text-align: left;
      padding: 20px 0 0 0;
      padding: 0 25px 40px 25px;
      margin: 0 auto;
  }
`
const Share = styled.div `
    // width: 100%;
    font-family: GmarketSansTTF;
    height: 100%;
    margin: 10px 30px;
    float: left;
    label {
      width: 100%;
      float: left;
      font-size: 16px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 24px;
      letter-spacing: normal;
      text-align: center;
      color: #dddddd;
    }
`
const SubLabel = styled.div`
      width: 100%;
      float: left;
      font-size: 16px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: #9a9a9a;
`
const ShareButton = styled.div`
    margin: 15px 0;
    width: 100%;
    height: 100%;
    float: left;
    img {
      width: 50px;
      height: 50px;
      padding: 15px 10px 16px;
      cursor: pointer;
    }
`
const ShareLink = styled.div`
    width: 70px;
    margin: 0 auto;
    padding: 0;
    float: left;
`
const Button = styled.button`
  font-family: GmarketSansTTFBold;
  width: 100%;
  height: 55px;
  margin: 30px 0 60px 0;
  border-radius: 8px;
  border: 0;
  outline: 0;
  background-color: #ffcf24;
  cursor: pointer;
  float: left;
  label {
      font-family: GmarketSansTTFBold;
      font-size: 24px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: #201d3a;
      cursor: pointer;
  }
}
`
const Youtube = styled.div`
    font-family: GmarketSansTTF;
    width: 100%;
    height: 177px;
    margin: 30px 0;
    float: left;
 
`
const App = styled.div`
    font-family: GmarketSansTTF;
    margin: 50px 0;
    width: 375px;
    height: 329px;
    background-color: #212338;
    float: left;
`
const AppContents = styled.div`
    margin: 40px 30px 60px 30px;
    label {
    font-family: GmarketSansTTF;
      margin: 30px 0;
      width: 100%;
      float: left;
      font-size: 16px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 26px;
      letter-spacing: normal;
      text-align: center;
      color: #dddddd;
    }
    label p {
        font-family: GmarketSansTTFBold;
    }
      label b {
        font-family: GmarketSansTTFBold;
        color: #ffffff;
    }
`
const AppButton = styled.div`
    cursor: pointer;
`
const Review = styled.div`
    font-family: GmarketSansTTF;
    width: 100%;
    height: 100%;
    float: left;
    img {
        width: 315px;
        height: 430px;
    }
    h1 {
      font-size: 32px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 42px;
      letter-spacing: normal;
      text-align: center;
      color: #ffffff;
      margin: 10px 0 20px 0;
      }
      label {
          font-size: 16px;
          font-weight: 500;
          font-stretch: normal;
          font-style: normal
          line-height: 24px;
          letter-spacing: normal;
          text-align: center;
          color: #dddddd;
          margin: 0 auto;
          }
`
const Event = styled.div`
    float: left;
    img {
    margin: 30px 0 0 0;
    width: 375px;
    }
`

const Footer = styled.div`
    float: left;
    width: 315px;
    margin: 30px 30px 57px 30px;
    padding: 0;
    img {
    width: 315px;
    height: 90px;
    float: left;
    }
    `

const Adress = styled.div`
        width: 100%;
        height: 100%;
        float: left;
        p {
          float: left;
          text-align: left;
          font-family: NotoSansCJKkr;
          font-size: 10px;
          font-weight: 500;
          font-stretch: normal;
          font-style: normal;
          line-height: normal;
          letter-spacing: normal;
          color: #dddddd;
          margin: 0 auto;
          padding: 0;
        }
`

const Company = styled.div`
        width: 100%;
        height: 100%;
        float: left;
        p {
          float: left;
          text-align: left;
          font-family: NotoSansCJKkr;
          font-size: 10px;
          font-weight: 500;
          font-stretch: normal;
          font-style: normal;
          line-height: normal;
          letter-spacing: normal;
          color: #dddddd;
        }
`